const GARAGE_MUTATION_TYPES = Object.freeze({
  APPEND_GARAGES: 'APPEND_GARAGES',
  APPEND_GARAGE_SEARCH_RESULTS: 'APPEND_GARAGE_SEARCH_RESULTS',
  APPEND_TIRECODES: 'APPEND_TIRECODES',

  SET_ERROR: 'SET_ERROR',
});

export default GARAGE_MUTATION_TYPES;
